import React from 'react';

export default function RabbitTailSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="38.0,29.77 11.05,29.77 8.4,7.1 35.35,7.1" fill="#F598C6" />
      <polygon points="11.05,29.77 38.0,29.77 31.6,35.4 4.65,35.4" fill="#EB3B92" opacity="0.95" />
      <polygon points="11.05,29.77 4.65,35.4 2.0,12.74 8.4,7.1" fill="#EB3B92" opacity="0.95" />
      <polygon points="38.0,29.77 11.05,29.77 8.4,7.1 35.35,7.1" fill="#F598C6" />
      <polygon points="11.05,29.77 38.0,29.77 31.6,35.4 4.65,35.4" fill="#EB3B92" opacity="0.95" />
      <polygon points="11.05,29.77 4.65,35.4 2.0,12.74 8.4,7.1" fill="#EB3B92" opacity="0.95" />
      <polygon points="33.87,36.03 10.77,36.03 13.42,16.01 36.52,16.01" fill="#F598C6" />
      <polygon points="10.77,36.03 33.87,36.03 27.46,23.99 4.37,23.99" fill="#EB3B92" opacity="0.95" />
      <polygon points="10.77,36.03 4.37,23.99 7.02,3.97 13.42,16.01" fill="#EB3B92" opacity="0.95" />
    </svg>
  );
}
